/* eslint-disable no-underscore-dangle */
import axios from '../../utils/axios';
import config from '../../config/index.json';
import store from '../../redux/store';
import { encode } from '../../utils/encode';
import getHeader from '../../utils/header';
import { getSecureOAuthToken } from '../../utils/tokenManager';

export const itemLookup = async (postData, type) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails.orderType;
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const headerParams = {
    headers: getHeader({ functionName: 'itemLookup.itemLookup', values: [type === 'orderType' ? orderTypeData ? `ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : '' : ''] }),
  };
  try {
    const resp = await axios.post(`${config.api.path}/items/${localStorage.getItem('StoreName')}/lookups/form?followlocation&zoom=availability,addtocartform,definition,definition:options:element:selector:choice,definition:options:element:selector:chosen,definition:options:element:selector:choice:description,definition:options:element:selector:chosen:description,code,offer,price,appliedpromotions,pricebreaks`, postData, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getRecommendations = async (postData, type) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails.orderType;
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const headerParams = {
    headers: getHeader({ functionName: 'itemLookup.getRecommendations', values: [type === 'orderType' ? orderTypeData ? `ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : '' : ''] }),
  };
  try {
    const resp = await axios.post(`${config.api.path}/items/${localStorage.getItem('StoreName')}/lookups/form?followlocation&zoom=recommendations:crosssell`, postData, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getFreezePeriod = async (type) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails.orderType;
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const { VITE_API_URL } = import.meta.env;
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const headerParams = {
    headers: {
      Authorization: getSecureOAuthToken(),
      'X-Ep-Account-Shared-Id': localStorage.getItem('defaultUserID'),
      'X-Ep-User-Traits': type === 'orderType' ? orderTypeData ? `ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},LOCALE=${authentication?.localeLanguage},PRICE_LIST_ID=${priceListId}` : '' : '',
    },
  };
  try {
    const resp = await axios.get(`${VITE_API_URL}${config.api.path}/samplesfreezeperiod/${localStorage.getItem('StoreName')}/freeze-period/${encode(authentication?.user?.CP_COUNTRY)}`, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export default {
  itemLookup,
  getRecommendations,
  getFreezePeriod,
};
